import React, { useState, useEffect } from "react";
//import { Button } from "reactstrap";
import httpService from "../../../services/http.service";
import "./cloudApp.css";
// import AdminDashboard from "./admincontent";
import CloudSidebar from "./sidebar";
import { Redirect, Route, Switch } from "react-router";

import { useHistory } from "react-router-dom";
import CloudDashboard from "./cloudDashboard";
import Version from "../../navbar/cloudversions/version";
import LicenseError from "../../licenseError/licenseerror";
import { cloudLicenceExpire } from "../../authentication/encryptanddecrypted/encryptAndDecrypt";
import ErrorMessage from "../../common/errorMsg";
import Loader from "../../common/loader";
import useUserSubscription from "../../common/userSubcriptionHook";

const CloudApp = (props) => {
  // const [sidebarClassesUser, setsidebarClassesUser] = useState([]);
  const [sidebarClassesProperty, setsidebarClassesProperty] = useState([]);
  const [sidebarClassesChannel, setsidebarClassesChannel] = useState([]);
  // const [userButtons, setuserButtons] = useState([]);
  const [propertyButtons, setpropertyButtons] = useState([]);
  const [channelsButtons, setchannelsButtons] = useState([]);
  const [backupLocation, setBackupLocation] = useState({});
  const [saved, setSaved] = useState(false);
  // const [onloads, setOnloads] = useState(true)
  const [open, setOpen] = useState(true)
  const [allProperties, setAllProperties] = useState([])
  const [allChannels, setAllChannels] = useState([])
  const [propertyToggles, setpropertyToggles] = useState()
  const [licenceExpire, setLicenceExpire] = useState(false)
  const [licenseIntervalId, setLicenseIntervalId] = useState(null);
  const { user, loading, checkActiveStatus } = useUserSubscription();
  const history = useHistory()
  // const [AdminData, setAdminData] = useState({});

  // useEffect(async() => {
  //  let l= await cloudLicenceExpire()
  // //  console.log(!l,"license")
  //   setLicenceExpire(!l)
  // }, []);


  useEffect(() => {
    const checkLicenseStatus = async () => {
      try {
        let isExpired = await cloudLicenceExpire();
        setLicenceExpire(!isExpired);
      } catch (error) {
        console.error("Error checking license status:", error);
      }
    };

    // Initial check
    checkLicenseStatus();

    // Set interval to check license status every 3 hours
    const intervalId = setInterval(checkLicenseStatus, 3 * 60 * 60 * 1000);

    // Clear interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (user) {
      checkActiveStatus()
    }
  }, [user, checkActiveStatus])




  useEffect(() => {
    const getBackupLocation = async () => {
      let data = { user: localStorage.getItem("Username") };

      let res = await httpService
        .CreateUpdate("getbackupLocation", data)
        .then((res) => res.data)
        .catch((err) => null);
      if (res) {
        setBackupLocation(res);
      }
    };
    getBackupLocation();
  }, [saved]);

  useEffect(() => {
    console.log(allProperties, "cloud app")

    // let userClasses = [...sidebarClassesUser];
    let propertyClasses = [...sidebarClassesProperty];
    let channelsClasses = [...sidebarClassesChannel];
    // let userButtonsTemp = [...userButtons];
    let propertyButtonsTemp = [...propertyButtons];
    let channelsButtonsTemp = [...channelsButtons];

    if (localStorage.getItem("propertyClasses"))
      propertyClasses = localStorage.getItem("propertyClasses").split(",");
    if (localStorage.getItem("channelsClasses"))
      channelsClasses = localStorage.getItem("channelsClasses").split(",");

    if (localStorage.getItem("propertyButtons"))
      propertyButtonsTemp = localStorage.getItem("propertyButtons").split(",");
    if (localStorage.getItem("channelsButtons"))
      channelsButtonsTemp = localStorage.getItem("channelsButtons").split(",");


    for (let i = 0; i < allProperties.length; i++) {
      if (i >= propertyClasses.length) {
        propertyClasses.push("0");
        propertyButtonsTemp.push("fa-plus-circle");
      }
    }

    for (let i = 0; i < allChannels.length; i++) {
      if (i >= channelsClasses.length) {
        channelsClasses.push("0");
        channelsButtonsTemp.push("fa-plus-circle");
      }
    }

    // setuserButtons(userButtonsTemp);
    setpropertyButtons(propertyButtonsTemp);
    setchannelsButtons(channelsButtonsTemp);
    // setsidebarClassesUser(userClasses);
    setsidebarClassesProperty(propertyClasses);
    setsidebarClassesChannel(channelsClasses);
    // localStorage.setItem("userClasses", userClasses);
    localStorage.setItem("propertyClasses", propertyClasses);
    localStorage.setItem("channelsClasses", channelsClasses);
    // localStorage.setItem("userButtons", userButtonsTemp);
    localStorage.setItem("propertyButtons", propertyButtonsTemp);
    localStorage.setItem("channelsButtons", channelsButtonsTemp);
  }, [allProperties]);

  useEffect(() => {
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    if (customerID === 'Admin' || type === "admin") {
      history.push("/admindashboard");
    }
  }, [])

  if (loading) {
    return <Loader />
  }

 

  return (
    <>{checkActiveStatus() ? <div>
      <LicenseError
        license={"license"}
        erroeMessage={"License has expired. Please Renew your subscriptions now"}
        contactno={"908-757-7444"}
      ></LicenseError>
    </div> :
      <div className="row">
        {/* new design--- */}
        {/* <div className=" left-sidefixed-outer">
          <CloudSidebar
            open={open}
            setOpen={setOpen}
            setAllProperties={setAllProperties}
            allProperties={allProperties}
            setAllChannels={setAllChannels}
            allChannels={allChannels}
            sidebarClassesProperty={sidebarClassesProperty}
            setsidebarClassesProperty={setsidebarClassesProperty}
            sidebarClassesChannel={sidebarClassesChannel}
            setsidebarClassesChannel={setsidebarClassesChannel}
            propertyButtons={propertyButtons}
            setpropertyButtons={setpropertyButtons}
            channelsButtons={channelsButtons}
            setchannelsButtons={setchannelsButtons}
            setpropertyToggles={setpropertyToggles}
            propertyToggles={propertyToggles}
          />
        </div> */}
        {/* -------// */}
        <div className="mainDivDashboard1">
          <Switch>


            <Route
              path="/clouddashboard"
              render={() => {
                return (
                  <CloudDashboard
                    open={open}
                    setOpen={setOpen}
                    setAllProperties={setAllProperties}
                    allProperties={allProperties}
                    setAllChannels={setAllChannels}
                    allChannels={allChannels}
                    setpropertyToggles={setpropertyToggles}
                    propertyToggles={propertyToggles}
                    verifyTokenUser={props.verifyTokenUser} setVerifyTokenUser={props.setVerifyTokenUser}
                  />

                );
              }}
            />
            <Route
              path="/about"
              render={() => {
                return (
                  <Version />

                );
              }}
            />




            <Redirect from="/" to={"/clouddashboard"} />
          </Switch>
        </div>
      </div>}
    </>
  );
};

export default CloudApp;

